export const BUNDLE_MODIFIER_TITLE = 'Bundle & Modifier Overrides';
export const BUNDLE_MODIFIER_DESCRIPTION = 'Specify scheme specific override prices for bundles or modifiers';
export const CREATE_BUNDLE_OR_MODIFIER_FIRST = 'Create a bundle or add modifiers to your products';
export const GO_TO_PRODUCTS = 'Go to Product Library';
export const BUNDLE_MODIFIER_FORM_ID = 'modifier-form';
export const BUNDLE_MODIFIER_UPDATE_MSG = {
  FAILURE: 'Failed to update bundle or modifier',
  SUCCESS: 'Price(s) updated!',
};
